// extracted by css-extract-rspack-plugin
export default {"root":"qsaaBzFrRScbaNtU","label":"r17sUU0Fz3QB84kB","tooltip":"gD0b8LzTvxkf0Un0"};